import styled from "styled-components";
import { theme } from "../../styles/theme";

export const StyledEtc_CurrentState = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  background-color: rgba(0, 0, 0, 0.5);

  &.isError {
    color: ${theme.colors.red};
  }
`